import { useContext } from 'react';

import { PrinterContext } from '..';

export const usePrinterContext = () => useContext(PrinterContext);
